// sessionStorage key: written by c-form-tracker.js on a successful D365 submit, read once and
// removed by c-modal.js. Session storage keeps it to this tab and clears it when the tab closes.
const BROCHURE_EMAIL_KEY = 'brochureRecipientEmail';
export default BROCHURE_EMAIL_KEY;
